export default "__VITE_ASSET__r4t0RHfL__"